import React from "react";
import { ITripStopItem } from "@types";
import { formatCategory } from "@utils";
import ChipStatus from "../../ChipStatus";
import { formatStopEta } from "./StopsSection";

interface StopDetailsProps {
  stop?: ITripStopItem;
}

const STOP_CATEGORY_LABELS: Record<string, string> = {
  LOAD_UNLOAD: "Carga/Descarga",
  LUNCH_REST: "Refeição/Descanso",
};

const Label: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="text-size-14 text-normal line-height-18 text-color-darkest">{children}</span>
);

const Value: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="text-size-16 text-normal line-height-20 text-color-darkest">{children}</span>
);

const Row: React.FC<{ label: string; icon?: string; children: React.ReactNode }> = ({ label, icon, children }) => (
  <div className="display-flex align-items-center justify-content-between padding-y-10 padding-x-15 border-bottom-width-1">
    <div className="display-flex align-items-center gap-4">
      {icon && <span className={`rioglyph ${icon} text-color-gray`} />}
      <Label>{label}</Label>
    </div>
    <div>{children}</div>
  </div>
);

const formatStopCategory = (category?: string | null): string => {
  if (!category) return "--";
  return STOP_CATEGORY_LABELS[category] || formatCategory(category) || category;
};

const formatArrival = (value?: string | null): string => (value ? formatStopEta(value) : "--");

export const StopDetails: React.FC<StopDetailsProps> = ({ stop }) => {
  if (!stop) return null;

  return (
    <div className="margin-top-15 flex-1-1 bg-white border rounded divider-y-1 divider-color-light divider-style-solid">
      <Row label="Parada" icon="rioglyph-pushpin">
        <Value>{stop.note}</Value>
      </Row>

      <Row label="Categoria">
        <Value>{formatStopCategory(stop.category)}</Value>
      </Row>

      <Row label="Status da parada">
        <div style={{ width: 130 }}>
          <ChipStatus status={stop.stopStatus} />
        </div>
      </Row>

      {stop.order !== undefined && (
        <Row label="Ordem">
          <Value>{`${stop.order}ª parada`}</Value>
        </Row>
      )}

      <Row label="Previsão de chegada" icon="rioglyph-time-alt">
        <Value>{formatArrival(stop.estimatedArrival)}</Value>
      </Row>

      {stop.lat !== undefined && stop.lng !== undefined && (
        <Row label="Coordenadas" icon="rioglyph-map-marker">
          <Value>{`${stop.lat.toFixed(6)}, ${stop.lng.toFixed(6)}`}</Value>
        </Row>
      )}
    </div>
  );
};
